"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = exports.ComponentDefaultParameters = void 0;
var react_1 = __importStar(require("react"));
var use_async_effect_1 = __importDefault(require("@n1ru4l/use-async-effect"));
var utils_1 = require("../../utils");
var hooks_1 = require("../../hooks");
// copied from https://github.com/arose/ngl/blob/d6a567ac/src/component/component.ts#L23
exports.ComponentDefaultParameters = {
    name: '',
    status: '',
    visible: true,
};
var defaultPosition = new utils_1.NGL.Vector3();
var defaultQuaternion = new utils_1.NGL.Quaternion();
var defaultScale = 1;
var defaultTransform = new utils_1.NGL.Matrix4();
exports.Component = function (_a) {
    var children = _a.children, path = _a.path, loadFileParams = _a.loadFileParams, _b = _a.params, params = _b === void 0 ? exports.ComponentDefaultParameters : _b, _c = _a.reprList, reprList = _c === void 0 ? [] : _c, _d = _a.position, position = _d === void 0 ? defaultPosition : _d, _e = _a.quaternion, quaternion = _e === void 0 ? defaultQuaternion : _e, _f = _a.scale, scale = _f === void 0 ? defaultScale : _f, _g = _a.transform, transform = _g === void 0 ? defaultTransform : _g, onLoad = _a.onLoad, onLoadFailure = _a.onLoadFailure;
    var stage = hooks_1.useStage();
    var _h = __read(react_1.useState(), 2), component = _h[0], setComponent = _h[1];
    use_async_effect_1.default(function loadFile(setCancelHandler, c) {
        var abortController, nextComponent, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    abortController = new AbortController();
                    setCancelHandler(function () { return abortController.abort(); });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [5 /*yield**/, __values(c(stage.loadFile(path, loadFileParams)))];
                case 2:
                    nextComponent = (_a.sent());
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    if (onLoadFailure) {
                        onLoadFailure(error_1);
                    }
                    return [3 /*break*/, 4];
                case 4:
                    if (nextComponent) {
                        setComponent(nextComponent);
                    }
                    return [2 /*return*/];
            }
        });
    }, [loadFileParams, onLoadFailure, path, stage]);
    react_1.useEffect(function () {
        if (component && onLoad) {
            onLoad(component);
        }
    }, [component, onLoad]);
    react_1.useEffect(function () {
        if (component) {
            var nextParams = utils_1.mergeParams(params, exports.ComponentDefaultParameters);
            if (nextParams.name !== component.parameters.name) {
                component.setName(nextParams.name);
            }
            if (nextParams.status !== component.parameters.status) {
                component.setStatus(nextParams.status);
            }
            if (nextParams.visible !== component.parameters.visible) {
                component.setVisibility(nextParams.visible);
            }
        }
    }, [component, params]);
    react_1.useEffect(function () {
        if (component) {
            component.removeAllRepresentations();
            reprList.forEach(function (repr) {
                return component.addRepresentation(repr.type, repr.params);
            });
        }
    }, [component, reprList]);
    react_1.useEffect(function () {
        if (component) {
            component.setPosition(position);
        }
    }, [component, position]);
    react_1.useEffect(function () {
        if (component) {
            component.setRotation(quaternion);
        }
    }, [component, quaternion]);
    react_1.useEffect(function () {
        if (component) {
            component.setScale(scale);
        }
    }, [component, scale]);
    react_1.useEffect(function () {
        if (component) {
            component.setTransform(transform);
        }
    }, [component, transform]);
    return (react_1.default.createElement(react_1.default.Fragment, null, component && (react_1.default.createElement(hooks_1.ComponentReactContext.Provider, { value: component }, children))));
};
//# sourceMappingURL=Component.js.map